<div [ngClass]="[class, shellClass, 'responsive-shell']">
  <div [ngClass]="[class, containerClass, 'responsive-container']">
    <ng-content></ng-content>
  </div>
</div>
